import reducer from './reducers';
import * as penStudyAnalysesActions from './actions';
import * as penStudyAnalysesSelectors from './selectors';

export { penStudyAnalysesActions, penStudyAnalysesSelectors };
export default reducer;